import { Outlet, useLocation, useNavigate } from "react-router-dom";

import { Tabs, View } from "../../components/base";

type AgentEvaluationTab = "evaluations" | "assignments" | "evaluate";

const evaluationTabs = [
  { id: "evaluations", label: "Evaluations" },
  { id: "assignments", label: "Assignments" },
  // TODO
  // { id: "evaluate", label: "Evaluate" },
];

export const AgentEvaluationPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const sectionPath = location.pathname.split("/evaluation/")[1] || "";
  const activeTab = (evaluationTabs.find((tab) => sectionPath.startsWith(tab.id))?.id || "evaluations") as AgentEvaluationTab;

  const handleTabChange = (tabId: string) => {
    if (tabId === activeTab) {
      return;
    }
    navigate(tabId);
  };

  return (
    <View className="h-full w-full overflow-hidden">
      <View className="flex flex-col gap-4 h-full min-h-0">
        <View className="px-4 pt-3">
          <Tabs
            tabs={evaluationTabs}
            activeTab={activeTab}
            onChange={handleTabChange}
          />
        </View>

        <View className="flex-1 min-h-0 overflow-hidden">
          <Outlet />
        </View>
      </View>
    </View>
  );
};
